import cn from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icons } from '@components/icons';
import { useClipboard } from '@hooks';
import TooltippedButton, { TooltippedButtonProps } from './tooltipped-button';
import { TextIconSpacing } from '@react-md/icon';

interface Props extends TooltippedButtonProps {}

export const DeleteIconButton = ({ className, theme, themeType, buttonType, disabled, children, ...props }: Props) => {
    const { t } = useTranslation();
    return (
        <TooltippedButton
            buttonType="icon"
            theme="error"
            // theme="clear"
            themeType="flat"
            className={cn('rmd-button--icon-circle', className)}
            tooltip={t('buttons.delete', 'Delete')}
            position="above"
            spacing={10}
            disableAutoSpacing
            {...props}
        >
            <Icons.Trash />
        </TooltippedButton>
    );
};

export const DuplicateIconButton = ({
    className,
    theme,
    themeType,
    buttonType,
    disabled,
    children,
    ...props
}: Props) => {
    const { t } = useTranslation();
    return (
        <TooltippedButton
            buttonType="icon"
            theme="clear"
            themeType="flat"
            className={cn('rmd-button--icon-circle', className)}
            tooltip={t('buttons.duplicate', 'Duplicate')}
            position="above"
            spacing={10}
            disableAutoSpacing
            {...props}
        >
            <Icons.Copy />
        </TooltippedButton>
    );
};

type ClipboardButtonProps = Partial<ReturnType<typeof useClipboard>> &
    Props & {
        label?: string;
    };

export const ClipboardButton = ({
    onCopy,
    value,
    hasCopied,
    label: _label,

    className,
    disabled,
    children,
    ...props
}: ClipboardButtonProps) => {
    const { t } = useTranslation();
    const label = _label ?? t('labels.copyClipboard', 'Copy to clipboard');
    const resultLabel = t('labels.copied', 'Copied');

    return (
        <TooltippedButton
            buttonType={children ? 'text' : 'icon'}
            theme="clear"
            themeType="flat"
            className={cn('rmd-button--icon-circle', className)}
            tooltip={hasCopied ? resultLabel : label}
            position="above"
            spacing={10}
            disableAutoSpacing
            onClick={onCopy}
            {...props}
        >
            {children ? (
                <TextIconSpacing icon={<Icons.Copy />} forceIconWrap>
                    {children}
                </TextIconSpacing>
            ) : (
                <Icons.Copy />
            )}
        </TooltippedButton>
    );
};
